module.exports = __webpack_public_path__ + "static/media/bg.b7ce382d.png";